import React, { useState } from 'react'

import { NavLink as RouterNavLink, NavLinkProps, useParams } from 'react-router-dom'
import { Add as AddIcon } from '@material-ui/icons'

import { useQueryPaginator } from 'src/components/Table'
import { DriverDetailTable } from 'src/components/Table/detail/Driver'
import { DriverDialog } from 'src/modules/supply_chain/components/DriverDialog'
import { EventListTable } from 'src/components/Table/list/Event'

import { skuit } from 'src/services/skuit'
import { useQuery } from 'react-query'

import { DetailPage } from 'src/components/Pages/DetailPage'
import { DetailTab } from 'src/components/Pages/Tab'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

interface PathProps {
  guid: string
}

const DefaultTab = () => {
  return null
}

const EventsTab = () => {
  const { guid } = useParams<PathProps>()

  const eventsPaginator = useQueryPaginator('event-list', skuit.sc.events.list, {
    params: { page_size: 5, references: guid },
  })

  return (
    <DetailTab>
      <EventListTable
        paginator={eventsPaginator}
        title="Driver Events"
        fields={['type', 'data', 'by', 'on']}
      />
    </DetailTab>
  )
}

export const DriverPage = () => {
  const { guid } = useParams<PathProps>()
  const [createOpen, setCreateOpen] = useState(false)

  const driver = useQuery(['driver-details', guid], () => skuit.sc.drivers.retrieve(guid))

  const refresh = () => {
    driver.refetch()
  }

  return (
    <>
      {createOpen && (
        <DriverDialog
          open={createOpen}
          handleClose={() => {
            setCreateOpen(false)
          }}
        />
      )}
      <DetailPage
        obj={driver}
        title="Driver"
        refresh={refresh}
        breadcrumbs={[
          { title: 'Dashboard', url: '/' },
          { title: 'Drivers', url: '/shipping/drivers' },
        ]}
        detailComponent={<DriverDetailTable obj={driver} refresh={refresh} />}
        menuItems={[
          {
            Icon: AddIcon,
            actions: [{ title: 'New Driver', onClick: () => setCreateOpen(true) }],
          },
        ]}
        tabs={['Details', 'Events']}
      >
        <DefaultTab />
        <EventsTab />
      </DetailPage>
    </>
  )
}
